import { PageCard } from './page-card'

export function ErrorView({
  title,
  description,
  button,
}: {
  title: string
  description: React.ReactNode
  button?: React.ReactNode
}) {
  return (
    <PageCard
      title={title}
      description={description}
      containerClassName="grow flex items-end" // push button to bottom of the card
    >
      {button}
    </PageCard>
  )
}
